export const HYPERTEST_JOB_LIST_DATA_API_CALL_LIMIT = 10;
export const HYPERTEST_DEFAULT_CONCURRENCY = 2;
export const HYPERTEST_DEFAULT_TIMEOUT = 90;
export const HYPERTEST_DEFAULT_RETRY = 1;
export const HYPERTEST_DEFAULT_FRAMEWORK_TYPE_TO_SHOW = 1;
export const SHOW_DEFAULT_ASSOCIATED_TESTS = 1;
export const SHOW_DEFAULT_ASSOCIATED_TESTS_FULL_SCREEN = 2;
export const HYPERTEST_DEFAULT_JOB_LABLE_COUNT = 3;
export const DEFAULT_FRAMEWORK_TYPE = 'Selenium';
